import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  checkEmpty,
  compareDate,
  decryptData,
  encryptData,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import PlTable from "../../../Components/ReportTables/PlTable";
import Loader from "../../../Components/Common/Loader";
import FromdateComponent from "../../Reports/FromdateComponent";
import TodateComponent from "../../Reports/TodateComponent";
import { toast } from "react-toastify";
import { Partner_Reports } from "../../../Configuration/Partner_URL";
import DurationChangeComponent from "../../Reports/DurationChangeComponent";
import { Modal } from "react-bootstrap";

function PnlReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");
  const partnerRoleNew = localStorage.getItem("partnerRoleNew");
  const clientName = localStorage.getItem("clientName");
  const clientCode = localStorage.getItem("clientCode");
  const [finalData, setFinalData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [dateError, setDateError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [seg, setSeg] = useState("stocks");
  const [errorGrid, setErrorGrid] = useState(false);
  const [customShow, setCustomShow] = useState(false)
  const [totalValues, setTotalValues] = useState({
    totalInvstmntAmt: 0,
    totalCurrentAmt: 0,
    totalRealizedPnl: 0,
    totalUnrealizedPnl: 0,
    totalPnl: 0,
  });
  const [scripData, setScripData] = useState([]);
  const [scripError, setScripError] = useState("");
  const [scripLoader, setScripLoader] = useState(false);
  const [scripExcelLoader, setScripExcelLoader] = useState(false);
  const [scripPdfLoader, setScripPdfLoader] = useState(false);
  const [selectedIsin, setSelectedIsin] = useState({
      isinVal: "", symbol: "", instType: "", optType: "", strikePrice: 0, expDate: ""
    });
  const [scripModal, setScripModal] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");
  const [reportVal, setReportVal] = useState("PNLRATE");
  const [showDateName, setShowDateName] = useState(false);
  const [scripName, setScripName] = useState("");
  const [selectDuration, setSelectDuration] = useState("");
  const [scriptDataSetTime, setScriptDataSetTime] = useState("");
  const [expiryDates, setExpiryDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [scripNames, setScripNames] = useState([]);


  // let clientCode = "";

  if (toDate == "" || fromDate == "") {
    // const current = new Date();
    // const CurrentYear = current.getFullYear();
    // const CurrentMonth = current.getMonth();
    // if (CurrentMonth < 4) {
    //   const newYear = `04-01-${CurrentYear - 1}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // } else {
    //   const newYear = `04-01-${CurrentYear}`;
    //   const date = `${current.getMonth() + 1
    //     }-${current.getDate()}-${current.getFullYear()}`;
    //   const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //   setFromDate(newYear);
    //   setToDate(date1);
    // }
    let date = new Date();
    let firstDay = "";
    let lastDay = "";
    let firstVal = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay = moment(firstVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    let lastVal = new Date();
    lastDay = moment(lastVal, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(firstDay)
    setToDate(lastDay)
  }

   const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${mm}-${dd}-${yyyy}`;
  };

  const getPnlReport = async (fileType = "grid", clientCode) => {
    setSmallLoaderExcel(fileType === "excel");
    setSmallLoaderPdf(fileType === "pdf");
    setSmallLoaderMail(fileType === "mail");
    setLoader(fileType === "grid");

    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      seg: seg,
      expiryDate: selectedDate ? formatToMMDDYYYY(selectedDate) : "",
      symbol: (seg === "fo" && scripName) || "",
      rate: seg === "stocks" ? reportVal : ""
    };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue9999");
    
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.PnlReport_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${partnerRoleNew === "Partner" ? partnerSsoToken : storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileType === "grid") {
          if (seg === "stocks") {
            setFinalData(res?.data?.pnlEqList);
            setTotalValues({
              totalInvstmntAmt: res?.data?.totalInvstmntAmt,
              totalCurrentAmt: res?.data?.totalCurrentAmt,
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          } else if (seg === "mf") {
            setFinalData(res?.data?.pnlMfList);
            setTotalValues({
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          } else {
            setFinalData(res?.data?.pnlFoList);
            setTotalValues({
              totalRealizedPnl: res?.data?.totalRealizedPnl,
              totalUnrealizedPnl: res?.data?.totalUnrealizedPnl,
              totalPnl: res?.data?.totalPnl,
            });
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setFinalData([]);
        if (fileType !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileType !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  const getScripData = async (type, isinVal, symbol, instType, optType, strikePrice, expDate) => {
    // const partyCode = localStorage.getItem("clientCode");
    setScripExcelLoader(type === "excel");
    setScripPdfLoader(type === "pdf");
    setScripLoader(type === "grid");

    const dateStr = expDate;
const [day, month, year] = dateStr.split("-");
const formattedDate = `${month}-${day}-${year}`;

    let payloadValue = {
      partyCode: clientCode,
      fromDate: fromDate,
      toDate: toDate,
      isin: seg === "fo" ? "" : isinVal,
      fileType: type,
      segType: seg === "stocks" ? "eq" : seg === "fo" ? "fo" : "" ,
      secName: symbol,
      instType: instType,
      optType: optType,
      strikePrice: strikePrice,
      expiryDate: expDate?.length > 0 ? formattedDate : ""

    };

    console.log(payloadValue, "payloadValueScrip");

    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.PnlReportScripHistory,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);
      console.log(res, "resresres");

      if (res?.status === 0) {
        console.log(res?.data, "ApiResDecrypt");
        if (type === "grid") {
          setScripData(res?.data?.tradeSummary);
        } else if (type === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (type === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setScripData([]);
        if (type !== "grid") {
          toast.error(res?.message)
        } else {
          setScripError(res?.message)
        }
      }
    } catch (error) {
      console.log(error);
      setScripError(error?.message)
      if (type !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setScripExcelLoader(false);
      setScripPdfLoader(false);
      setScripLoader(false);
    }
  };

  const handleScripModal = (type, isinVal, symbol, instType, optType, strikePrice, expDate) => {
     const isinData = {
    isinVal,
    symbol,
    instType,
    optType,
    strikePrice,
    expDate
  };
   
      getScripData(type, isinVal, symbol, instType, optType, strikePrice, expDate)
      setSelectedIsin(isinData)
    setScripModal(true);
  }

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleSegmentChange = (e) => {
    setFinalData([]);
    setSeg(e.target.value);
    setErrorGrid(false);
  };

  const handleFromDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setFinalData([]);
    setErrorGrid(false);
    setDateError(false);
    setServerError(false);
  };
  const handleToDateChange = (e) => {
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorGrid(false);
    setFinalData([]);
    setDateError(false);
    setServerError(false);
  };
  useEffect(() => {
    if (clientCode || ClientId2) {
      // clientCode = localStorage.getItem("clientCode");
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        getPnlReport("grid", clientCode);
      } else {
        setFinalData([]);
      }
    }
  }, []);
  const handleOnClick = (e) => {
    if (clientCode || ClientId2) {
      // clientCode = localStorage.getItem("clientCode");
      if (fromDate.length > 0 && toDate.length > 0 && seg.length > 0) {
        if (e.target.value) {
          if (
            compareDate(fromDate) &&
            compareDate(toDate) &&
            checkDateRange(fromDate, toDate)
          ) {
            getPnlReport(e.target.value, clientCode);
            setDateError(false);
          } else {
            setDateError("Please Select Correct Date");
          }
        }
      }
    }
  };

  useEffect(() => {
      if (clientCode && selectDuration && seg === "fo") {
        scripnamedropdown(clientCode)
        if (selectDuration === "custom") {
          setShowDateName(false)
          return
        } else {
          expirydatedropdown(clientName, fromDate, toDate);
  
        }
        console.log(selectDuration, "selectDuration");
      }
      else {
        setShowDateName(false)
      }
    }, [clientName, seg, selectDuration, fromDate, toDate]);

    const expirydatedropdown = async () => {
        console.log(clientName, "clientCode");
        setShowDateName(true)
        if (fromDate && toDate && clientName) {
          var data = {
            clientCode: clientName,
            fromDate: fromDate,
            toDate: toDate,
          };
        }
        console.log(data, "data");
        setScriptDataSetTime("Data loading....")
        let encPayload = AESEncryption(data);
        try {
          const response = await axios.post(
            Dashboard_Client_Report.Expirydatedropdown,
            encPayload,
            {
              headers: {
                "content-Type": "application/json",
                reserv: 1,
                Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
              },
            }
          );
          const data = await response.data;
          let editResponse = ApiResDecrypt(data);
          console.log(editResponse, "editResponse");
          if (editResponse.status == 0) {
            setScriptDataSetTime("---Select Expiry Date---")
            setExpiryDates(editResponse.data);
          } else {
            setExpiryDates([])
            setScriptDataSetTime("Expiry Date does not exist")
          }
    
          // setTimeout(() => {
          //   setExpiryDates(editResponse.data);
          // }, 500);
    
        } catch (err) {
    
        }
      }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  function formatDateValue(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr; // fallback if invalid
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

  const showModalActiveData = (scripData) => {
    return (
      scripData &&
      scripData.map((info, key) => {
        return (
          <tr key={key}>
            <td>
              {checkEmpty(info?.saudaDt) ? "-" : formatDateValue(info?.saudaDt)}
            </td>
            <td>{checkEmpty(info?.scripName) ? "-" : info?.scripName}</td>

            <td>
              {checkEmpty(info?.isin) ? "-" : info?.isin}
            </td>
            <td>
              {checkEmpty(info?.txnProdType) ? "-" : info?.txnProdType}
            </td>
            <td>
              {checkEmpty(info?.trdQty) ? "-" : info?.trdQty}
            </td>
            <td>
              {checkEmpty(info?.pnlRate) ? "-" : info?.pnlRate}
            </td>
            <td>
              {checkEmpty(info?.txnVal) ? "-" : info?.txnVal}
            </td>
            <td>
              {checkEmpty(info?.rmrk) ? "-" : info?.rmrk}
            </td>
            <td>
              {checkEmpty(info?.flag) ? "-" : info?.flag}
            </td>
          </tr>
        );
      })
    );
  };
  console.log(scripData, "scripDataNew");

const handleReportType =(e)=> {
    setFinalData([]);
    setReportVal(e?.target?.value);
    setErrorGrid(false);
  }

  const onChangeDuration = () => {
    setErrorGrid(false);
    setFinalData([]);
    setDateError(false);
    setServerError(false);
  }

  const scripnamedropdown = async (clientNum) => {
    let data = {
      clientCode: clientNum
    };
    console.log(data, "data");
    let encPayload = AESEncryption(data);
    try {
      const response = await axios.post(
        // 'https://uat-cosmos.bajajfinservsecurities.in/api/rm/Report/scripnamedropdown',
        Dashboard_Client_Report.Scripnamedropdown,
        encPayload,
        {
          headers: {
            "content-Type": "application/json",
            reserv: 1,
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
          },
        }
      );
      const data = await response.data;
      let editResponse = ApiResDecrypt(data);
      console.log(editResponse, "editResponse");
      setScripNames(editResponse.data || []);
    } catch (err) {

    }
  }
  
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="pnl-report"
        role="tabpanel"
        aria-labelledby="pnl-report"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                {/* <div className="d-flex"> */}
                <div className="form-group" >
                  <DurationChangeComponent
                    setCustomShow={setCustomShow}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    className="report-custom-select"
                    screen="Client Dashboard"
                    onChangeDuration={onChangeDuration}
                    setSelectDuration={setSelectDuration}
                    selectDuration={selectDuration}
                    reportName = {"pnl"}
                  />
                </div>
                {customShow && <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                />}

                {customShow && <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={dateError}
                />}
                {/* </div> */}
                {/* <div className="d-flex"> */}
                <div className="form-group">
                  <label className="form-label">Segment: </label>
                  <select
                    onChange={handleSegmentChange}
                    className="report-custom-select"
                  >
                    <option value="stocks">{Constants.EQ}</option>
                    <option value="mf">{Constants.MF}</option>
                    <option value="fo">{Constants.FandO}</option>
                    <option value="curfo">{Constants.Currency}</option>
                  </select>
                </div>

                {showDateName &&
                <div className="form-group">
                  <label className="form-label">Scrip Name</label>

                  <select
                    // className="input-st"
                    className="report-custom-select"
                    value={scripName}
                    onChange={(e) => setScripName(e?.target?.value)}
                  >
                    <option value="">-- Select Scrip --</option>
                    {scripNames.length > 0 ? <>
                      {scripNames.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </> : <option value="">Scrip Name does not exist</option>}

                  </select>
                </div>
              }
            {showDateName &&
                <div className="form-group">
                  <label className="form-label">Expiry Date </label>
                  <select
                    // className="input-st"
                    className="expiry-dropdown report-custom-select"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  >
                    {expiryDates.length > 0 ? <>
                      <option value="">{scriptDataSetTime}</option>
                      {expiryDates.map((date, index) => (
                        <option key={index} value={date}>
                          {date}
                        </option>
                      ))}</> :
                      <>
                        <option value="">{scriptDataSetTime}</option>
                      </>
                    }


                  </select>
                </div>
            }

                {seg === "stocks" &&
                <div className="form-group">
                  <label className="form-label">Report Type: </label>
                  <select 
                    className="report-custom-select"
                    onChange={handleReportType}>
                    <option value="PNLRATE">PNL Rate</option>
                    <option value="NETRATE">Net Rate</option>
                  </select>
                </div>
            }

                {/* </div> */}
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-pdfsvg"></span> */}

              {Constants.Submit}
            </button>
          </div>

          {/* <div className="col-md-3 col-sm-3 col-6"> */}

          {/* </div> */}

          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                // <div>
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>

            <button
              value="excel"
              onClick={handleOnClick}
              className="generate-button excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="for-grid-section pnl-wrapper">
        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : finalData && finalData.length > 0 ? (
          <div>
            <PlTable data={finalData} seg={seg} totalValues={totalValues} handleScripModal={handleScripModal} />
          </div>
        ) : serverError ? (
          <h4 className="report-error-message">{noDataFound(serverError)}</h4>
        ) : (
          errorGrid && noDataFound(errorGrid)
        )}
      </div>
      <Modal
        show={scripModal}
        onHide={() => setScripModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              <h2 className="h2-css-all">Trade Summary</h2>
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setScripModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table">
            {scripLoader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : scripData && scripData?.length > 0 ?
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th>{Constants.Date}</th>
                      <th>{Constants.Symbol}</th>
                      <th>{Constants.Isin}</th>
                      <th>{Constants.Exchange}</th>
                      <th>{Constants.Quantity}</th>
                      <th>Price</th>
                      <th>Order Value</th>
                      <th>Remark</th>
                      <th>Flag</th>
                    </tr>
                  </thead>

                  <tbody>
                    {showModalActiveData(scripData)}
                  </tbody>
                </table>
                {console.log(selectedIsin, "selectedIsin")}

                <div className="generate-btn-wrapper">
                  <button
                    className="generate-btn text-green"
                    value="excel"
                     onClick={() =>
                      handleScripModal(
                        "excel",
                        selectedIsin?.isinVal,
                        selectedIsin?.symbol,
                        selectedIsin?.instType,
                        selectedIsin?.optType,
                        selectedIsin?.strikePrice,
                        selectedIsin?.expDate
                      )
                    }
                  >
                    {scripExcelLoader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-excelsvg"></span>
                        {"Excel"}
                      </>
                    )}
                  </button>
                  <button
                    className="generate-btn txt-purple"
                     onClick={() =>
                      handleScripModal(
                        "pdf",
                        selectedIsin?.isinVal,
                        selectedIsin?.symbol,
                        selectedIsin?.instType,
                        selectedIsin?.optType,
                        selectedIsin?.strikePrice,
                        selectedIsin?.expDate
                      )
                    }
                    value="pdf"
                  >
                    {scripPdfLoader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-pdfsvg"></span> {"PDF"}
                      </>
                    )}
                  </button>
                </div>
              </>
              : scripError && noDataFound(scripError)
            }
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default PnlReportNew;
